let envInitialized = false;
const e = {};
const env = (envFnOrEnv) => {
    e.init = (...args) => {
        if (envInitialized) {
            console.warn("initEnv() - Can't initialize env more then once");
            return;
        }
        envInitialized = true;
        delete e.init;
        Object.assign(e, typeof envFnOrEnv === 'function' ? envFnOrEnv(...args) : envFnOrEnv);
        Object.freeze(e);
    };

    return e;
};

export default env;
